import { render } from "./HomePage.vue?vue&type=template&id=dd58bd14&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=dd58bd14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd58bd14"]])

export default __exports__